import { useState } from 'react'

import { Box, Button, CollapsableCard, Text } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

import { useMaterializedApprovalFlowHistory } from 'modules/approvals/hooks/useMaterializedApprovalFlows'

import { Content } from './Content'
import EmptyState from './EmptyState'

interface ApprovalInformationBlockProps {
  resourceId: string
  resourceType: string
  newLook?: boolean
  defaultOpen?: boolean
  showBoxWhenLoading?: boolean
}

// Block informing about the status of an specific resource
const ApprovalsInformationBlock = ({
  resourceId,
  resourceType,
  newLook,
  defaultOpen,
  showBoxWhenLoading,
}: ApprovalInformationBlockProps) => {
  const [openHistory, setOpenHistory] = useState(defaultOpen ?? true)

  const { loading, materializedApprovalFlow } = useMaterializedApprovalFlowHistory(
    resourceId,
    resourceType
  )

  if (loading && !showBoxWhenLoading) {
    return <Loading />
  }

  if (newLook) {
    return materializedApprovalFlow ? (
      <Content materializedApprovalFlow={materializedApprovalFlow} newLook={newLook} />
    ) : (
      <EmptyState />
    )
  }

  return (
    <Box>
      <CollapsableCard
        open={openHistory}
        contentPadding="s0"
        contentBackground="lighter000"
        Card={
          <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal>
              {i18n.t('settings.approvals.approval_request_view.approval_history.title')}
            </Text.Normal>
            <Button
              onClick={() => setOpenHistory(() => !openHistory)}
              type="secondary"
              iconName={`${openHistory ? 'chevron-up' : 'chevron-down'}`}
            />
          </Box>
        }
        Content={
          materializedApprovalFlow ? (
            <>
              <Content materializedApprovalFlow={materializedApprovalFlow} />
            </>
          ) : (
            <EmptyState />
          )
        }
      />
    </Box>
  )
}

export default ApprovalsInformationBlock
